import { Sector } from '@/domain/impact/impact.entity';
import { Category } from '@/domain/impact-co2/entities/question.entity';

import { ImportedRow } from '../../convert-excel-to-impact-answers';
import { mapToCategory, mapToSector } from './shared-mapper';

export function filterRowsByCategory(category: Category) {
  return (row: ImportedRow) => mapToCategory(row) === category;
}

export function filterRowsBySectors(sectors: Sector[]) {
  return (row: ImportedRow) => {
    const rowSector = mapToSector(row);
    return sectors.includes(rowSector);
  };
}
